import { Row, Col, Form, Input, Select, DatePicker, Spin, Button } from "antd";

import {
  BILLING_CYCLE,
  HOTEL_TYPE,
  YES_NO_OPTION,
  isSuperAdmin,
  urlRegex,
  whatsappRegex,
  phoneRegex,
  colProps,
  ACTIVE_INACTIVE_OPTION,
  getSetting,
  BILL_DUE_WARNING,
  BILL_BLOCK_SYSTEM,
} from "../../../constants/constent";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { displayMessage, getAPI, postAPI } from "../../../utils/common";
import {
  ERROR_MSG_TYPE,
  SUBFAILED,
  SUCCESS_MSG_TYPE,
} from "../../../constants/messages";
import { CREATE_VENDOR, EDIT_VENDOR, LOCATIONS } from "../../../constants/api";
import LS_SERVICE from "../../../utils/localStorage";
import { useNavigate } from "react-router-dom";
import JoditEditor from "jodit-react";

const { Option } = Select;

function VendorProfileTab({
  bdes,
  plans,
  edit_id,
  handleTabChange,
  setEditId,
  vendor,
  fetchVendorDetail,
}) {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);

  const [countryID, setCountryID] = useState(102);
  const [stateID, setStateID] = useState(null);

  const [form] = Form.useForm();

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const init = async () => {
    console.log("vendor: ", vendor);

    if (!vendor) {
      await handleCreateInit();
    }
  };

  useEffect(() => {
    if (!vendor) return;
    setLoading(true);

    const countryId = vendor.hotel_country_id;
    const stateId = vendor.hotel_state_id;

    setCountryID(countryId);
    setStateID(stateId);

    fetchLocations(countryId, stateId);

    form.setFieldsValue({
      ...vendor,
      setup_charage_amount: parseInt(vendor?.setup_charage_amount ?? 0),
      status: vendor.status,
      hotel_type: vendor.hotel_type,
      billing_cycle: vendor.billing_cycle,
      auto_bill_generation: vendor.auto_bill_generation ? 1 : 0,
      chm_active: vendor.chm_active ? 1 : 0,
      is_approved: vendor.is_approved ? 1 : 0,
      document_approved: vendor.document_approved ? 1 : 0,
      billing_start_date: vendor.billing_start_date
        ? dayjs(vendor.billing_start_date)
        : null,
      expected_live_date: vendor.expected_live_date
        ? dayjs(vendor.expected_live_date)
        : null,
      is_sponserd: vendor.is_sponserd ? 1 : 0,
    });
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendor]);

  const handleCreateInit = async () => {
    setLoading(true);
    const config = await getSetting();

    form.setFieldsValue({
      setup_charage_amount: parseInt(config?.setup_charage_amount ?? 0),
      hotel_country_id: countryID,
      billing_cycle: 1,
      auto_bill_generation: 1,
      hotel_type: "hotel",
      status: "pending",
      is_approved: 0,
      chm_active: 0,
      document_approved: 0,
      bill_due_reminder_in_day: BILL_DUE_WARNING,
      bill_due_block_system_in_day: BILL_BLOCK_SYSTEM,
      is_sponserd: 0,
      ...(isSuperAdmin() ? {} : { sales_man_id: LS_SERVICE.get("id") }),
    });

    fetchLocations(countryID);
    setLoading(false);
  };

  const fetchLocations = (countryId, stateId = null) => {
    setLoading(true);
    const url =
      LOCATIONS + (countryId ?? "") + (stateId ? `&state_id=${stateId}` : "");

    getAPI(
      url,
      (res) => {
        setCountry(res.countries || []);
        setState(res.states || []);
        setCity(res.cities || []);
        setLoading(false);
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Unable to fetch locations");
      },
    );
  };

  /* ================= HANDLERS ================= */

  const handleLocationChange = (key, value) => {
    form.setFieldsValue({ [key]: value });

    if (key === "hotel_country_id") {
      setCountryID(value);
      setStateID(null);
      fetchLocations(value);
    }

    if (key === "hotel_state_id") {
      setStateID(value);
      fetchLocations(countryID, value);
    }
  };
  const handlePlanChange = (key, value) => {
    if (key === "active_plan_id") {
      const selectedPlan = plans.find((e) => e.id === value);

      if (!selectedPlan) return;

      if (form.getFieldValue("billing_cycle") === 12) {
        form.setFieldsValue({
          active_plan_amount: selectedPlan.plan_yearly_price,
        });
      } else {
        form.setFieldsValue({
          active_plan_amount: selectedPlan.plan_monthly_price,
        });
      }
    } else if (key === "billing_cycle") {
      const selectedPlan = plans.find(
        (e) => e.id === form.getFieldValue("active_plan_id"),
      );

      if (!selectedPlan) return;

      if (value === 12) {
        form.setFieldsValue({
          active_plan_amount: selectedPlan.plan_yearly_price,
        });
      } else {
        form.setFieldsValue({
          active_plan_amount: selectedPlan.plan_monthly_price,
        });
      }
    }
  };

  const onSubmit = (values) => {
    setLoading(true);
    const payload = {
      ...values,
      expected_live_date: values.expected_live_date?.format("YYYY-MM-DD"),
      billing_start_date: values.billing_start_date?.format("YYYY-MM-DD"),
      auto_bill_generation: !!values.auto_bill_generation,
    };
    console.log("On Submit the Vendor Profile Form : ", payload);
    postAPI(
      !edit_id ? CREATE_VENDOR : EDIT_VENDOR,
      payload,
      (res) => {
        if (res.status) {
          displayMessage(SUCCESS_MSG_TYPE, res.message);
          if (!edit_id) {
            navigate(-1);
          } else {
            setEditId(res.data.id);
            handleTabChange("2");
          }
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
        setLoading(false);
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, SUBFAILED);
      },
    );
  };

  /* ================= JSX ================= */
  return (
    <Spin spinning={loading}>
      <Form form={form} layout="vertical" onFinish={onSubmit}>
        <Row gutter={[16, 16]}>
          <Form.Item name="id" />
          <Col {...colProps}>
            <Form.Item
              name="sales_man_id"
              label="Assign BDE"
              rules={[{ required: true }]}
            >
              <Select placeholder="Select BDE" disabled={!isSuperAdmin()}>
                {bdes.map((bde) => (
                  <Option key={bde.id} value={bde.id}>
                    {bde.name} ({bde.employee_code})
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col {...colProps}>
            <Form.Item
              name="vendor_name"
              label="Vendor Name"
              rules={[
                {
                  required: true,
                  message: "Vendor name is required",
                },
                {
                  min: 3,
                  message: "Minimum 3 characters required",
                },
              ]}
            >
              <Input placeholder="Vendor Name" />
            </Form.Item>
          </Col>
          <Col {...colProps}>
            <Form.Item
              name="hotel_name"
              label="Hotel Name"
              rules={[
                {
                  required: true,
                  message: "Hotel name is required",
                },
                {
                  min: 3,
                  message: "Minimum 3 characters required",
                },
              ]}
            >
              <Input placeholder="Hotel Name" />
            </Form.Item>
          </Col>
          <Col {...colProps}>
            <Form.Item name="hotel_contact_person" label="Contact Person">
              <Input placeholder="Contact Person" />
            </Form.Item>
          </Col>
          <Col {...colProps}>
            <Form.Item
              name="hotel_whatsapp_no"
              label="WhatsApp No"
              rules={[
                {
                  pattern: whatsappRegex,
                  message: "Enter valid WhatsApp number",
                },
              ]}
            >
              <Input placeholder="WhatsApp Number" />
            </Form.Item>
          </Col>
          <Col {...colProps}>
            <Form.Item
              name="hotel_mobile_no"
              label="Mobile No"
              rules={[
                {
                  required: true,
                  message: "Mobile number is required",
                },
                {
                  pattern: phoneRegex,
                  message: "Enter valid 10-digit Indian mobile number",
                },
              ]}
            >
              <Input placeholder="Mobile Number" />
            </Form.Item>
          </Col>
          <Col {...colProps}>
            <Form.Item
              name="hotel_email_id"
              label="Email"
              rules={[
                {
                  required: true,
                  message: "Email address is required",
                },
                {
                  type: "email",
                  message: "Enter valid email address",
                },
              ]}
            >
              <Input placeholder="Email ID" />
            </Form.Item>
          </Col>
          <Col {...colProps}>
            <Form.Item name="hotel_area" label="Area">
              <Input placeholder="Area" />
            </Form.Item>
          </Col>
          <Col {...colProps}>
            <Form.Item
              name="hotel_country_id"
              label="Country ID"
              rules={[
                {
                  required: true,
                  message: "Country is required",
                },
              ]}
            >
              <Select
                loading={loading}
                placeholder="Select Country"
                showSearch
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
                onChange={(value) =>
                  handleLocationChange("hotel_country_id", value)
                }
                options={
                  country &&
                  country.map((e) => ({
                    value: e.id,
                    label: e.name,
                  }))
                }
              />
            </Form.Item>
          </Col>
          <Col {...colProps}>
            <Form.Item
              name="hotel_state_id"
              label="State ID"
              rules={[
                {
                  required: true,
                  message: "State is required",
                },
              ]}
            >
              <Select
                loading={loading}
                disabled={countryID === null || state === null}
                placeholder="Select State"
                showSearch
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
                onChange={(value) =>
                  handleLocationChange("hotel_state_id", value)
                }
                options={
                  state &&
                  state.map((e) => ({
                    value: e.id,
                    label: e.name,
                  }))
                }
              />
            </Form.Item>
          </Col>
          <Col {...colProps}>
            <Form.Item
              name="hotel_city_id"
              label="City ID"
              rules={[
                {
                  required: true,
                  message: "City is required",
                },
              ]}
            >
              <Select
                loading={loading}
                disabled={stateID === null || city === null}
                placeholder="Select City"
                showSearch
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
                onChange={(value) => handleLocationChange("city_id", value)}
                options={
                  city &&
                  city.map((e) => ({
                    value: e.id,
                    label: e.name,
                  }))
                }
              />
            </Form.Item>
          </Col>
          <Col {...colProps}>
            <Form.Item
              name="hotel_type"
              label="Hotel Type"
              rules={[
                {
                  required: true,
                  message: "Hotel type is required",
                },
              ]}
            >
              <Select placeholder="Select" options={HOTEL_TYPE} allowClear />
            </Form.Item>
          </Col>
          <Col {...colProps}>
            <Form.Item
              name="billing_cycle"
              label="Billing Cycle"
              rules={[
                {
                  required: true,
                  message: "Billing cycle is required",
                },
              ]}
            >
              <Select
                placeholder="Select"
                options={BILLING_CYCLE}
                onChange={(value) => handlePlanChange("billing_cycle", value)}
              />
            </Form.Item>
          </Col>
          <Col {...colProps}>
            <Form.Item
              name="active_plan_id"
              label="Subscription Plans"
              rules={[
                {
                  required: true,
                  message: "Please select a plan",
                },
              ]}
            >
              <Select
                placeholder="Select"
                options={
                  plans &&
                  plans.map((e) => ({
                    value: e.id,
                    label: e.plan_name,
                  }))
                }
                allowClear
                onChange={(value) => handlePlanChange("active_plan_id", value)}
              />
            </Form.Item>
          </Col>

          {isSuperAdmin() ? (
            <>
              <Col {...colProps}>
                <Form.Item
                  name="chm_active"
                  label="CHM Active"
                  tooltip="Channel Manager Status"
                >
                  <Select placeholder="Select" options={YES_NO_OPTION} />
                </Form.Item>
              </Col>

              <Col {...colProps}>
                <Form.Item
                  name="chm_hotel_code"
                  label="CHM Hotel Code"
                  tooltip="Channel Manager Hotel Code"
                >
                  <Input placeholder="Hotel Code" />
                </Form.Item>
              </Col>

              <Col {...colProps}>
                <Form.Item
                  name="url"
                  label="Website URL"
                  tooltip="Must be like: https://hotelnxt.com"
                  rules={[
                    {
                      pattern: urlRegex,
                      message: "Enter valid website URL",
                    },
                  ]}
                >
                  <Input placeholder="Website URL" />
                </Form.Item>
              </Col>

              <Col {...colProps}>
                <Form.Item name="status" label="Status">
                  <Select
                    placeholder="Select"
                    options={ACTIVE_INACTIVE_OPTION}
                  />
                </Form.Item>
              </Col>

              <Col {...colProps}>
                <Form.Item name="document_approved" label="Document Approved">
                  <Select placeholder="Select" options={YES_NO_OPTION} />
                </Form.Item>
              </Col>

              <Col {...colProps}>
                <Form.Item name="is_approved" label="Approved">
                  <Select placeholder="Select" options={YES_NO_OPTION} />
                </Form.Item>
              </Col>

              <Col {...colProps}>
                <Form.Item
                  name="active_plan_amount"
                  label="Plan Amount"
                  disabled
                >
                  <Input />
                </Form.Item>
              </Col>

              <Col {...colProps}>
                <Form.Item
                  name="setup_charage_amount"
                  label="Setup Charge Amount"
                  rules={[
                    {
                      pattern: /^\d+$/,
                      message: "Only numeric value allowed",
                    },
                  ]}
                >
                  <Input readOnly />
                </Form.Item>
              </Col>

              <Col {...colProps}>
                <Form.Item
                  name="expected_live_date"
                  label="Expected Live Date"
                  rules={[{ required: true }]}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    disabledDate={undefined}
                    format="YYYY-MM-DD"
                  />
                </Form.Item>
              </Col>

              <Col {...colProps}>
                <Form.Item
                  name="billing_start_date"
                  label="Billing Start Date"
                  rules={[
                    {
                      required: true,
                      message: "Billing start date is required",
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    disabledDate={undefined}
                    format="YYYY-MM-DD"
                  />
                </Form.Item>
              </Col>

              <Col {...colProps}>
                <Form.Item
                  name="bill_due_reminder_in_day"
                  tooltip="After the bill genration Bill Due Reminder on Software"
                  label={"Reminder Days"}
                  rules={[
                    {
                      pattern: /^\d+$/,
                      message: "Only positive numbers allowed",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>

              <Col {...colProps}>
                <Form.Item
                  name="bill_due_block_system_in_day"
                  tooltip="After the bill genration Bill Due Block the Software"
                  label="Block System Days"
                  rules={[
                    {
                      pattern: /^\d+$/,
                      message: "Only positive numbers allowed",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>

              <Col {...colProps}>
                <Form.Item name="is_sponserd" label="Sponserd">
                  <Select placeholder="Select" options={YES_NO_OPTION} />
                </Form.Item>
              </Col>

              <Col {...colProps}>
                <Form.Item
                  name="auto_bill_generation"
                  label="Auto Bill Generation"
                  tooltip="Automatically generate subscription bills via the daily cron for this vendor"
                >
                  <Select placeholder="Select" options={YES_NO_OPTION} />
                </Form.Item>
              </Col>
            </>
          ) : (
            <></>
          )}

          <Col {...colProps}>
            <Form.Item
              name="google_ratting"
              tooltip="Google Ratting Like: 4.2"
              label="Google Ratting"
              rules={[
                {
                  pattern: /^\d+(\.\d{1,2})?$/,
                  message:
                    "Only numeric value allowed (up to 2 decimal places)",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="hotel_description" label="Hotel Description">
              <JoditEditor placeholder="Hotel Description" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="remark" label="Remark">
              <Input.TextArea rows={3} />
            </Form.Item>
          </Col>
        </Row>
        <Row spceber>
          <Col span={24}>
            <Form.Item
              style={{ float: "right", marginTop: 20 }}
              label=""
              colon={false}
            >
              <Button loading={loading} block htmlType="submit">
                {edit_id ? "Update" : "Submit"}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
}
export default VendorProfileTab;
